import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

/**
 * Dispatched when a QF 3S request is sent.
 *
 * NOTE: Can be expanded in the future to track query requests as well.
 */
const onServiceRequest = action(
    'onServiceRequest',
    (scenarioId: SearchScenarioId, requestId: string) => ({
        scenarioId,
        requestId,
    })
);

export default onServiceRequest;
